import React, { useState } from 'react';
import { message, Select, Button } from 'antd';
import { Card, Col, Container, Row } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router';
import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';

import Loader from '../../common-components/loader';
import constants from '../../constants';
import authAxios from '../../authorization/axios';
//interface IBillingCodesGeneratorState {
//  loading: boolean,
//  previousMonth?: boolean
//}

const BillingCodesGenerator = () => {
  const { t } = useTranslation();
  // constructor(props: WithTranslation) {
  // super(props);
  //   this.state = {
  //     loading: false
  //   };
  // }
  const [previousMonth, setPreviousMonth] = useState<boolean | undefined>(undefined);
  const [loading, setLoading] = useState<boolean>(false);

  const generateCodes = async (type: 'invoices' | 'credit-notes') => {
    setLoading(true);
    try {
      const url = type === 'invoices' ? constants.api.generateBillingCodes : constants.api.generateCreditNoteCodes;
      await authAxios.post(url, {}, {
        params: {
          previousMonth: previousMonth
        }
      });
      setLoading(false);
      const placeholder = type === 'invoices' ? 'GENERATION_INVOICES_SUCCESS' : 'GENERATION_CREDIT_NOTE_SUCCESS';
      message.success({
        content: <span>{t(placeholder)}</span>,
        style: {
          marginTop: 100
        }
      });
    } catch (error: any) {
      console.error(error);
      setLoading(false);
      const placeholder = type === 'invoices' ? 'GENERATION_INVOICES_FAILED' : 'GENERATION_CREDIT_NOTE_FAILED';
      message.error({
        content: <span>
          {t(placeholder, {
            errorMsg: error.response?.data.errorMessage || error.message || 'generic error'
          })}
        </span>,
        style: {
          marginTop: 100
        }
      });
    }
  };

  const getPeriod = () => {
    const today = DateTime.now().setZone('Europe/Paris');
    let limitDate = today
      .minus({ days: 3 })
      .endOf('day');
    if (previousMonth && today.month === limitDate.month) {
      limitDate = limitDate.minus({ months: 1 }).endOf('month');
    } else if (!previousMonth && today.month !== limitDate.month) {
      limitDate = today.startOf('month');
    }
    const startDate = limitDate.startOf('month');

    return { start: startDate.toFormat('dd-LL-yyyy 00:00'), end: limitDate.toFormat('dd-LL-yyyy HH:mm') };
  };

  return (
    <Container fluid>
      <Loader fullscreen={true} visible={loading} />
      <Card>
        <Card.Body>
          <h3>{t('GENERATE_BILLING_CODES')}</h3>
          <Row>
            <Col className='p-2'>
              <Select
                className='mr-2'
                value={previousMonth !== undefined ? previousMonth?.toString() : undefined}
                onChange={(e) => setPreviousMonth(e === 'true')}
                style={{ width: 200 }}
              >
                <Select.Option value={'false'}>{t('CURRENT_MONTH')}</Select.Option>
                <Select.Option value={'true'}>{t('PREVIOUS_MONTH')}</Select.Option>
              </Select>
              <Button
                className='mr-2'
                disabled={previousMonth === undefined}
                type='primary'
                onClick={() => generateCodes('invoices')}
              >
                {t('GENERATE_BILLING_CODES')}
              </Button>
            </Col>
          </Row>
          {
            previousMonth !== undefined &&
            <Row>
              <Col className='p-2 pt-1'>
                <small>{t('GENERATE_CODES_INFO', getPeriod())}</small>
              </Col>
            </Row>
          }
        </Card.Body>
      </Card>
    </Container>
  );
};

export default withTranslation()(withRouter(BillingCodesGenerator as any));